import { render } from "./Recorridos.vue?vue&type=template&id=2c6972fe"
import script from "./Recorridos.vue?vue&type=script&lang=js"
export * from "./Recorridos.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/gasoil/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__